import { Box, Grid, Tab, Tabs } from '@mui/material'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PageUrls from '../../../../constants/page-urls'
import DailySalesByDistributionReport from './DailySalesByDistributionReport'
import DailyReturnReport from './DailyReturnReport'
import DailySalesReport from './DailySaleReport'
import DailyTelesalesReport from './DailyTelesaleReport'

const Menus: any[] = []

export interface IMerchantDailyReport {
  merchant: string
  date: string
  count: number
  unit: number
  discount: number
  subTotal: number
  total: number
  commission: number
  commissionOrder: number
  commissionPercent: number
  codTotal: number
  codCount: number
  bankTotal: number
  bankCount: number
  hasTracking: number
  noTracking: number
  costTotal: number
  upsaleTotal?: number
  unsuccessUpSaleTotal?: number
}

export interface ICostDailyReport {
  merchant: string
  amount: number
  date: string
  adsActive: number
  adsInactive: number
  shipping: number
}

const DailySalesReportPage = () => {
  const navigate = useNavigate()
  const [value, setValue] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // Each tab builds its initial filter from the URL; clear it so the next tab doesn't inherit the previous tab's filters
    navigate(PageUrls.Report.DailySales, { replace: true })
    setValue(newValue)
  }
  return (
    <ContentWrapper>
      <Helmet title="รายงานยอดขาย" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายงานยอดขาย"
            routes={Menus}
            descriptions="รายงานยอดขาย"
          />
        </Grid>
      </Grid>
      <Tabs value={value} onChange={handleChange} aria-label="report tabs">
        <Tab label="รายงานยอดขาย" />
        <Tab label="รายงาน Telesale" />
        <Tab label="รายงานยอดขาย แยกเพจ" />
        <Tab label="รายงานตีกลับ" />
      </Tabs>
      <Box mt={3} display={value === 0 ? 'block' : 'none'}>
        <DailySalesReport />
      </Box>
      <Box mt={3} display={value === 1 ? 'block' : 'none'}>
        {value === 1 && <DailyTelesalesReport />}
      </Box>
      <Box mt={3} display={value === 2 ? 'block' : 'none'}>
        {value === 2 && <DailySalesByDistributionReport />}
      </Box>
      <Box mt={3} display={value === 3 ? 'block' : 'none'}>
        {value === 3 && <DailyReturnReport />}
      </Box>
    </ContentWrapper>
  )
}

export default DailySalesReportPage
